import regmatch from './regmatch';
import customer from './customer';
import agent from './agent';
import monitoring from './inspection';
import members from './members';

const wizards:any = {
  agent:{
    add:agent,
  },
  monitoring:{
    add:monitoring,
  },
  customer:{
    add:customer
  },
  members:{
    add:members
  },
  identity:{
    process:regmatch,
  }
}
//TODO: create single card error wizard as default using try/catch 
const findWizard = (service:string) => (action:string) => {
  return wizards[service][action];
}

const getWizard = (service:string,action:string) => {
  return wizards[service][action];
}

export {findWizard,getWizard};
export default wizards;
